import React from 'react'
import classnames from 'classnames'

const EventImageAspectRatioContainer = ({ className, ...rest }) => (
  <div className={classnames('h-0 relative aspect-ratio-event-image', className)} {...rest} />
)

export default EventImageAspectRatioContainer
